import React, { useState } from "react";
import payrollService from "../../services/payrollService";
import Notification from "../../components/UI/Notification";
import { Upload, Download } from "lucide-react";

const BulkSalaryUpdate = () => {
  const [file, setFile] = useState(null);
  const [loading, setLoading] = useState(false);
  const [notification, setNotification] = useState(null);

  const handleDownloadTemplate = async () => {
    try {
      const blob = await payrollService.downloadSalaryTemplate();
      const url = window.URL.createObjectURL(new Blob([blob]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download", "salary_template.xlsx");
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      setNotification({ type: "error", message: "Failed to download template" });
    }
  };

  const handleFileChange = (e) => {
    setFile(e.target.files[0]);
  };

  const handleUpload = async () => {
    if (!file) {
      setNotification({ type: "warning", message: "Please select a file" });
      return;
    }
    setLoading(true);
    try {
      const formData = new FormData();
      formData.append("file", file);
      const response = await payrollService.importSalaryStructures(formData);
      if (response.success) {
        setNotification({
          type: "success",
          message: `Imported ${response.data.success} records successfully`,
        });
        setFile(null);
      }
    } catch (error) {
      setNotification({ type: "error", message: "Failed to import data" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="p-6 font-poppins">
      {notification && (
        <Notification
          type={notification.type}
          message={notification.message}
          onClose={() => setNotification(null)}
        />
      )}

      <div className="mb-6">
        <h1 className="text-3xl font-bold text-gray-900 dark:text-white">
          Bulk Salary Update
        </h1>
        <p className="text-gray-600 dark:text-gray-400 mt-1">
          Update multiple salaries at once
        </p>
      </div>

      <div className="bg-white dark:bg-gray-800 rounded-lg shadow-md p-6">
        <div className="space-y-4">
          <div>
            <button
              onClick={handleDownloadTemplate}
              className="flex items-center gap-2 px-4 py-2 bg-green-600 hover:bg-green-700 text-white rounded-md font-medium"
            >
              <Download size={18} />
              Download Template
            </button>
            <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
              Download the Excel template, fill in salary details, and upload it back
            </p>
          </div>

          <div className="border-t border-gray-200 dark:border-gray-700 pt-4">
            <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
              Upload Filled Template
            </label>
            <input
              type="file"
              accept=".xlsx,.xls"
              onChange={handleFileChange}
              className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 dark:bg-gray-700 dark:text-white"
            />
            {file && (
              <p className="text-sm text-gray-600 dark:text-gray-400 mt-2">
                Selected: {file.name}
              </p>
            )}
          </div>

          <button
            onClick={handleUpload}
            disabled={loading || !file}
            className="flex items-center gap-2 px-4 py-2 bg-blue-600 hover:bg-blue-700 text-white rounded-md font-medium disabled:opacity-50"
          >
            <Upload size={18} />
            {loading ? "Uploading..." : "Upload & Process"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default BulkSalaryUpdate;

